
//公共库
import { Component, Vue } from "vue-property-decorator";

//本地引入
import DTCls from "@/utils/datetime";
import Pagination from "@/comp/Pagination/index.vue";
import { shqsLogList, shqsRankList } from "@/api/request/activity";
import { parseTime } from "@/utils";

//组件
@Component({
  name: "HongBaoYu",
  components: {
    Pagination,
  },
})

//界面函数
export default class extends Vue {
  //定义变量
  private list: any[] = [];
  private total: number = 0;
  private listLoading: boolean = false;

  //列表请求参数
  private listQuery: any = {
    //页面数据
    page: 1, //当前页
    page_size: 10, //页大小

    //临时数据
    time: [], //到期时间
    user_id_str: "", //用户ID
    blogger_id_str: "", //博主ID

    //请求数据
    user_id: 0, //用户ID
    blogger_id: 0, //博主ID
    end_time: "", //申请结束时间
    start_time: "", //申请开始时间
    audit_status: -1, //审核状态：-1-全部，0-待审核，1-已通过，2-已拒绝
  };

  //时间参数
  get pickerOptions(): any {
    return {
      shortcuts: [
        {
          text: "今日",
          onClick(picker: any) {
            picker.$emit("pick", [new Date(DTCls.getTodayStartTime()), new Date(DTCls.getTodayEndTime())]);
          },
        },
        {
          text: "昨日",
          onClick(picker: any) {
            picker.$emit("pick", [new Date(DTCls.getYesterdayStartTime()), new Date(DTCls.getYesterdayEndTime())]);
          },
        },
        {
          text: "本周",
          onClick(picker: any) {
            picker.$emit("pick", [new Date(DTCls.getCurWeekStartTime()), new Date(DTCls.getTodayEndTime())]);
          },
        },
        {
          text: "上周",
          onClick(picker: any) {
            picker.$emit("pick", [new Date(DTCls.getLastWeekStartTime()), new Date(DTCls.getLastWeekEdnTime())]);
          },
        },
        {
          text: "本月",
          onClick(picker: any) {
            picker.$emit("pick", [new Date(DTCls.getCurMonthStartTime()), new Date(DTCls.getTodayEndTime())]);
          },
        },
        {
          text: "上月",
          onClick(picker: any) {
            picker.$emit("pick", [new Date(DTCls.getLastMonthStartTime()), new Date(DTCls.getLastMonthEndTime())]);
          },
        },
        {
          text: "最近一周",
          onClick(picker: any) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          text: "最近一个月",
          onClick(picker: any) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          text: "最近三个月",
          onClick(picker: any) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          text: "全部",
          onClick(picker: any) {
            picker.$emit("pick", []);
          },
        },
      ],
    };
  }

  //状态列表
  private statusList: any[] = [
    { status: -1, name: "全部状态" },
    { status: 0, name: "待审核" },
    { status: 1, name: "已通过" },
    { status: 2, name: "已拒绝" },
  ];

  //排行榜列表
  private rankingList: any[] = [
    { type: "", name: "排行榜" },
    { type: "week", name: "周榜" },
    { type: "month", name: "月榜" },
  ];

  //创建
  created() {
    //获取列表
    this.getList();
  }

  //获取列表
  private async getList() {
    //显示等待
    this.listLoading = true;

    //时间赋值
    if (this.listQuery.time && this.listQuery.time.length == 2) {
      this.listQuery.end_time = this.listQuery.time[1];
      this.listQuery.start_time = this.listQuery.time[0];
    } else {
      this.listQuery.end_time = "";
      this.listQuery.start_time = "";
    }
    this.listQuery.user_id = Number(this.listQuery.user_id_str);
    this.listQuery.blogger_id = Number(this.listQuery.blogger_id_str);

    //获取数据
    const { data } = await shqsLogList(this.listQuery);

    //数据赋值
    this.list = data.list;
    this.total = data.total;

    //隐藏等待
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  //处理查询
  private handleFilter(): void {
    //数据赋值
    this.listQuery.page = 1;

    //获取列表
    this.getList();
  }

  //处理时间
  private handleTime(time: number): string {
    return parseTime(time) as string;
  }

  //-------------------------- 排行榜 --------------------------
  //定义变量
  private rankingType: string = "";
  private rankingTitle: string = "";
  private dialogVisible: boolean = false;
  private dialogLoading: boolean = false;
  private rankingDataList: Array<any> = [];

  //修改排行榜类型
  private async onChangeRankingType() {
    //数据赋值
    if (this.rankingType != "") {
      //显示等待
      this.dialogLoading = true;
      this.dialogVisible = true;
      this.rankingTitle = (this.rankingType == "week" ? "周" : "月") + "排行榜";

      //获取数据
      const { data } = await shqsRankList({ type: this.rankingType });

      //数据赋值
      this.rankingDataList = data.list;
      this.rankingType = "";

      //隐藏等待
      setTimeout(() => {
        this.dialogLoading = false;
      }, 0.5 * 1000);
    }
  }
}
